module.exports = __webpack_public_path__ + "static/media/previousquestionseamcet.b58f0d2e.jpeg";